import {FC, useState, createContext, useContext, Dispatch, SetStateAction} from 'react'

import {WithChildren} from '../../../../_metronic/helpers'

type InvestorContextProps = {
  blockOutsideClick:boolean
  setBlockOutsideClick: Dispatch<SetStateAction<boolean>>
  allInvestorCurrentPage: number
  setAllInvestorCurrentPage: Dispatch<SetStateAction<number>>
  existingInvestorCurrentPage: number
  setExistingInvestorCurrentPage: Dispatch<SetStateAction<number>>
  prospectiveInvestorCurrentPage: number
  setProspectiveInvestorCurrentPage: Dispatch<SetStateAction<number>>
  allInvestorTab: number
  setAllInvestorTab: Dispatch<SetStateAction<number>>
  prospectiveInvestorTab: number
  setProspectiveInvestorTab: Dispatch<SetStateAction<number>>
  searchValue: string | undefined
  storeSearchValue: Dispatch<SetStateAction<string | undefined>>
  companyName: string | undefined
  setCompanyName: Dispatch<SetStateAction<string | undefined>>
  investorUser: string | undefined
  setinvestorUser: Dispatch<SetStateAction<string | undefined>>
  investorId: string | undefined
  storeInvestorId: Dispatch<SetStateAction<string | undefined>>
  investorDbFilter: boolean
  setInvestorDbFilter: Dispatch<SetStateAction<boolean>>
  sort_by_investorDb: string | undefined
  set_sort_by_investorDb: Dispatch<SetStateAction<string | undefined>>
  sort_order_investorDb: string | undefined
  set_sort_order_investorDb: Dispatch<SetStateAction<string | undefined>>
  searchInvestorUpdate: string | undefined
  storeSearchInvestorUpdate: Dispatch<SetStateAction<string | undefined>>
  searchPitchDeck: string | undefined
  storeSearchPitchDeck: Dispatch<SetStateAction<string | undefined>>
  investorUpdateFilter: boolean
  setInvestorUpdateFilter: Dispatch<SetStateAction<boolean>>
  pitchDeckFilter: boolean
  setPitchDeckFilter: Dispatch<SetStateAction<boolean>>
  investorUpdateStatusFilter: string | undefined
  setInvestorUpdateStatusFilter: Dispatch<SetStateAction<string | undefined>>
  willRun: boolean
  setWillRun: Dispatch<SetStateAction<boolean>>
  investorUpdateLoading: boolean
  setInvestorUpdateLoading: Dispatch<SetStateAction<boolean>>
  investorUpdate: any | undefined
  setInvestorUpdate: Dispatch<SetStateAction<any | undefined>>
  willDeleteRun: boolean
  setWillDeleteRun: Dispatch<SetStateAction<boolean>>
  willCopyRun: boolean
  setWillCopyRun: Dispatch<SetStateAction<boolean>>
  isEditing: boolean
  setIsEditing: Dispatch<SetStateAction<boolean>>
  willEditRun: boolean
  setWillEditRun: Dispatch<SetStateAction<boolean>>
  pitchDeckStatusFilter: string | undefined
  setpitchDeckStatusFilter: Dispatch<SetStateAction<string | undefined>>
  pitchDeckModalShow: boolean
  setPitchDeckModalShow: Dispatch<SetStateAction<boolean>>
  storeFileName: string | undefined
  setStoreFileName: Dispatch<SetStateAction<string | undefined>>
  searchTemplate: string | undefined
  storeSearchTemplate: Dispatch<SetStateAction<string | undefined>>
  templateFilter: boolean
  setTemplateFilter: Dispatch<SetStateAction<boolean>>
  templateStatusFilter: string | undefined
  setTemplateStatusFilter: Dispatch<SetStateAction<string | undefined>>

  searchEmail: string | undefined
  storeSearchEmail: Dispatch<SetStateAction<string | undefined>>
  emailFilter: boolean
  setEmailFilter: Dispatch<SetStateAction<boolean>>
  emailStatusFilter: string | undefined
  setEmailStatusFilter: Dispatch<SetStateAction<string | undefined>>
  investorUpdatePLoading: boolean
  setInvestorUpdatePLoading: Dispatch<SetStateAction<boolean>>
  dataRoomFilter: boolean
  setDataRoomFilter: Dispatch<SetStateAction<boolean>>
  refreshFuncActivityLog: boolean
  setRefreshFuncActivityLog: Dispatch<SetStateAction<boolean>>
  contextTargetSectors: any
  setContextTargetSectors: Dispatch<SetStateAction<any>>
  contextStageFocus: any
  setContextStageFocus: Dispatch<SetStateAction<any>>
  contextInvestorLocation: any
  setContextInvestorLocation: Dispatch<SetStateAction<any>>
  selectedContextTargetValue: any
  setSelectedContextTargetValue: Dispatch<SetStateAction<any>>
  selectedStageContextFocusValue: any
  setSelectedStageContextFocusValue: Dispatch<SetStateAction<any>>
  selectedTargetContextLocationValue: any
  setSelectedTargetContextLocationValue: Dispatch<SetStateAction<any>>
  contextInvestorGeographies: any
  setContextInvestorGeographies: Dispatch<SetStateAction<any>>
  selectedTargetContextGeographiesValue: any
  setSelectedTargetContextGeographiesValue: Dispatch<SetStateAction<any>>
  selectedTargetContextInvestorTypeValue: any
  setSelectedTargetContextInvestorTypeValue: Dispatch<SetStateAction<any>>
}

const initInvestorContextPropsState = {
  blockOutsideClick:false,
  setBlockOutsideClick: ()=>{},
  allInvestorCurrentPage: 1,
  setAllInvestorCurrentPage: () => {},
  existingInvestorCurrentPage: 1,
  setExistingInvestorCurrentPage: () => {},
  prospectiveInvestorCurrentPage: 1,
  setProspectiveInvestorCurrentPage: () => {},
  allInvestorTab: 2,
  setAllInvestorTab: () => {},
  prospectiveInvestorTab: 1,
  setProspectiveInvestorTab: () => {},
  searchValue: undefined,
  storeSearchValue: () => {},
  companyName: undefined,
  setCompanyName: () => {},
  investorUser: undefined,
  setinvestorUser: () => {},
  investorId: undefined,
  storeInvestorId: () => {},
  investorDbFilter: false,
  setInvestorDbFilter: () => {},
  sort_by_investorDb: '',
  set_sort_by_investorDb: () => {},
  sort_order_investorDb: undefined,
  set_sort_order_investorDb: () => {},
  searchInvestorUpdate: undefined,
  storeSearchInvestorUpdate: () => {},
  searchPitchDeck: undefined,
  storeSearchPitchDeck: () => {},
  investorUpdateFilter: false,
  setInvestorUpdateFilter: () => {},
  pitchDeckFilter: false,
  setPitchDeckFilter: () => {},
  investorUpdateStatusFilter: undefined,
  setInvestorUpdateStatusFilter: () => {},
  willRun: false,
  setWillRun: () => {},
  willDeleteRun: false,
  setWillDeleteRun: () => {},
  willCopyRun: false,
  setWillCopyRun: () => {},
  willEditRun: false,
  setWillEditRun: () => {},
  investorUpdateLoading: false,
  setInvestorUpdateLoading: () => {},
  investorUpdate: undefined,
  setInvestorUpdate: () => {},
  isEditing: false,
  setIsEditing: () => {},
  pitchDeckStatusFilter: undefined,
  setpitchDeckStatusFilter: () => {},
  pitchDeckModalShow: false,
  setPitchDeckModalShow: () => {},
  storeFileName: undefined,
  setStoreFileName: () => {},
  searchTemplate: undefined,
  storeSearchTemplate: () => {},
  templateFilter: false,
  setTemplateFilter: () => {},
  templateStatusFilter: undefined,
  setTemplateStatusFilter: () => {},
  searchEmail: undefined,
  storeSearchEmail: () => {},
  emailFilter: false,
  setEmailFilter: () => {},
  emailStatusFilter: undefined,
  setEmailStatusFilter: () => {},
  investorUpdatePLoading: false,
  setInvestorUpdatePLoading: () => {},
  dataRoomFilter: false,
  setDataRoomFilter: () => {},
  refreshFuncActivityLog: false,
  setRefreshFuncActivityLog: () => {},
  contextTargetSectors: [],
  setContextTargetSectors: () => {},
  contextStageFocus: [],
  setContextStageFocus: () => {},
  contextInvestorLocation: [],
  setContextInvestorLocation: () => {},
  selectedContextTargetValue: '',
  setSelectedContextTargetValue: () => {},
  selectedStageContextFocusValue: '',
  setSelectedStageContextFocusValue: () => {},
  selectedTargetContextLocationValue: '',
  setSelectedTargetContextLocationValue: () => {},
  contextInvestorGeographies: [],
  setContextInvestorGeographies: () => {},
  selectedTargetContextGeographiesValue: '',
  setSelectedTargetContextGeographiesValue: () => {},
  selectedTargetContextInvestorTypeValue: '',
  setSelectedTargetContextInvestorTypeValue: () => {},
}

const InvestorContext = createContext<InvestorContextProps>(initInvestorContextPropsState)

const useInvestorDatabase = () => {
  return useContext(InvestorContext)
}

const InvestorDatabaseProvider: FC<WithChildren> = ({children}) => {
  const [searchValue, storeSearchValue] = useState<string | undefined>('')
  const [blockOutsideClick, setBlockOutsideClick] = useState<boolean>(false)

  //InvestorDB
  const [allInvestorCurrentPage, setAllInvestorCurrentPage] = useState<number>(1)
  const [existingInvestorCurrentPage, setExistingInvestorCurrentPage] = useState<number>(1)
  const [prospectiveInvestorCurrentPage, setProspectiveInvestorCurrentPage] = useState<number>(1)
  const [allInvestorTab, setAllInvestorTab] = useState<number>(2)
  const [prospectiveInvestorTab, setProspectiveInvestorTab] = useState<number>(1)
  const [investorDbFilter, setInvestorDbFilter] = useState<boolean>(false)
  const [sort_by_investorDb, set_sort_by_investorDb] = useState<string | undefined>('')
  const [sort_order_investorDb, set_sort_order_investorDb] = useState<string | undefined>('')
  const [contextTargetSectors, setContextTargetSectors] = useState<any>()
  const [contextStageFocus, setContextStageFocus] = useState<any>()
  const [contextInvestorLocation, setContextInvestorLocation] = useState<any>()
  const [selectedContextTargetValue, setSelectedContextTargetValue] = useState<any>('')
  const [selectedStageContextFocusValue, setSelectedStageContextFocusValue] = useState<any>('')
  const [selectedTargetContextLocationValue, setSelectedTargetContextLocationValue] =
    useState<any>('')
  const [contextInvestorGeographies, setContextInvestorGeographies] = useState<any>()
  const [selectedTargetContextGeographiesValue, setSelectedTargetContextGeographiesValue] =
    useState<any>('')
  const [selectedTargetContextInvestorTypeValue, setSelectedTargetContextInvestorTypeValue] =
    useState<any>('')
  //InvestorUpdate Search and Filtering
  const [searchInvestorUpdate, storeSearchInvestorUpdate] = useState<string | undefined>()
  const [investorUpdateFilter, setInvestorUpdateFilter] = useState<boolean>(false)
  const [investorUpdateStatusFilter, setInvestorUpdateStatusFilter] = useState<string | undefined>(
    undefined
  )
  //InvestorUpdate
  const [willRun, setWillRun] = useState<boolean>(false)
  const [willDeleteRun, setWillDeleteRun] = useState<boolean>(false)
  const [willEditRun, setWillEditRun] = useState<boolean>(false)
  const [willCopyRun, setWillCopyRun] = useState<boolean>(false)
  const [isEditing, setIsEditing] = useState<boolean>(false)
  const [investorUpdate, setInvestorUpdate] = useState<any>()
  const [investorUpdateLoading, setInvestorUpdateLoading] = useState<boolean>(false)
  const [investorUpdatePLoading, setInvestorUpdatePLoading] = useState<boolean>(false)
  const [pitchDeckFilter, setPitchDeckFilter] = useState<boolean>(false)
  const [pitchDeckStatusFilter, setpitchDeckStatusFilter] = useState<string | undefined>(undefined)
  const [searchPitchDeck, storeSearchPitchDeck] = useState<string | undefined>()

  const [templateFilter, setTemplateFilter] = useState<boolean>(false)
  const [templateStatusFilter, setTemplateStatusFilter] = useState<string | undefined>(undefined)
  const [searchTemplate, storeSearchTemplate] = useState<string | undefined>()

  const [storeFileName, setStoreFileName] = useState<string | undefined>(undefined)

  //pichdeck modal
  const [pitchDeckModalShow, setPitchDeckModalShow] = useState(false)

  const [companyName, setCompanyName] = useState<string | undefined>()
  const [investorUser, setinvestorUser] = useState<string | undefined>()
  const [investorId, storeInvestorId] = useState<string | undefined>()

  //email
  const [emailFilter, setEmailFilter] = useState<boolean>(false)
  const [emailStatusFilter, setEmailStatusFilter] = useState<string | undefined>(undefined)
  const [searchEmail, storeSearchEmail] = useState<string | undefined>()
  const [refreshFuncActivityLog, setRefreshFuncActivityLog] = useState<boolean>(false)

  //DataRoom Filter
  const [dataRoomFilter, setDataRoomFilter] = useState<boolean>(false)
  return (
    <InvestorContext.Provider
      value={{
        blockOutsideClick,
        setBlockOutsideClick,
        allInvestorCurrentPage,
        setAllInvestorCurrentPage,
        existingInvestorCurrentPage,
        setExistingInvestorCurrentPage,
        prospectiveInvestorCurrentPage,
        setProspectiveInvestorCurrentPage,
        allInvestorTab,
        setAllInvestorTab,
        prospectiveInvestorTab,
        setProspectiveInvestorTab,
        searchValue,
        storeSearchValue,
        setCompanyName,
        companyName,
        setinvestorUser,
        investorUser,
        investorId,
        storeInvestorId,
        investorDbFilter,
        setInvestorDbFilter,
        sort_by_investorDb,
        set_sort_by_investorDb,
        sort_order_investorDb,
        set_sort_order_investorDb,
        searchInvestorUpdate,
        storeSearchInvestorUpdate,
        searchPitchDeck,
        storeSearchPitchDeck,
        investorUpdateFilter,
        setInvestorUpdateFilter,
        pitchDeckFilter,
        setPitchDeckFilter,
        investorUpdateStatusFilter,
        setInvestorUpdateStatusFilter,
        willRun,
        setWillRun,
        investorUpdateLoading,
        setInvestorUpdateLoading,
        investorUpdatePLoading,
        setInvestorUpdatePLoading,
        investorUpdate,
        setInvestorUpdate,
        willDeleteRun,
        setWillDeleteRun,
        willCopyRun,
        setWillCopyRun,
        isEditing,
        setIsEditing,
        willEditRun,
        setWillEditRun,
        pitchDeckStatusFilter,
        setpitchDeckStatusFilter,
        pitchDeckModalShow,
        setPitchDeckModalShow,
        storeFileName,
        setStoreFileName,
        searchTemplate,
        storeSearchTemplate,
        templateFilter,
        setTemplateFilter,
        templateStatusFilter,
        setTemplateStatusFilter,
        searchEmail,
        storeSearchEmail,
        emailFilter,
        setEmailFilter,
        emailStatusFilter,
        setEmailStatusFilter,
        setDataRoomFilter,
        dataRoomFilter,
        refreshFuncActivityLog,
        setRefreshFuncActivityLog,
        contextTargetSectors,
        setContextTargetSectors,
        contextStageFocus,
        setContextStageFocus,
        contextInvestorLocation,
        setContextInvestorLocation,
        selectedContextTargetValue,
        setSelectedContextTargetValue,
        selectedStageContextFocusValue,
        setSelectedStageContextFocusValue,
        selectedTargetContextLocationValue,
        setSelectedTargetContextLocationValue,
        contextInvestorGeographies,
        setContextInvestorGeographies,
        selectedTargetContextGeographiesValue,
        setSelectedTargetContextGeographiesValue,
        selectedTargetContextInvestorTypeValue,
        setSelectedTargetContextInvestorTypeValue,
      }}
    >
      {children}
    </InvestorContext.Provider>
  )
}

export {InvestorDatabaseProvider, useInvestorDatabase}
